import { call, put, takeEvery } from "redux-saga/effects";
import Swal from "sweetalert2";
import * as types from "./matrixservicerequestActionType";
import * as actions from "./matrixservicerequestAction";
import * as services from "./matrixservicerequestServices";
import { downloadBase64File } from "../../../../utils/fileDownloads";
import SweetAlert from "../../../../components/sweetalert/SweetAlert";

//Get All Encore Service Request Saga
function* MatrixServiceRequestSaga(action) {
  try {
    const response = yield call(
      services.GetAllMatrixServiceRequest,
      action.payload,
    );

    if (!response) {
      throw new Error("No response received from API");
    }

    // Swal.fire({
    //     icon: "success",
    //     title: "Success",
    //     text: "Encore Service Request created successfully",
    //     confirmButtonText: "OK"
    // });

    yield put(actions.fetchMatrixServiceRequestSuccess(response));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      "Failed to create Encore Service Request";
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });

    console.error("Create Encore Service Request API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    yield put(actions.fetchMatrixServiceRequestFailure(errorMessage));
  }
}

//Get All Facility Onboarding Planner Dropdown Lists Saga
function* fetchAllsiteonboardingplannerlists(action) {
  try {
    const value = action?.payload ?? false;

    const response = yield call(
      services.GetAllsiteonboardingplannerlists,
      value,
    );
    if (!response) {
      throw new Error("No response received from API");
    }

    yield put(actions.siteonboardingplannerSuccess(response?.values));
  } catch (error) {
    const errorMessage = "Failed to fetch Facility Alias Management List";
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      showConfirmButton: true,
    });
    console.error("Facility Alias Management List API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    yield put(actions.siteonboardingplannerFailure(errorMessage));
  }
}

//Get Worklist by RPCE Id Saga
function* getworklistbyRpceIDSaga(action) {
  try {
    // Extract payload from action
    const { rpceIds } = action.payload;

    // Call API with rpceIds
    const response = yield call(services.GetWorklistByRPCEId, rpceIds);

    if (response?.success) {
      yield put(actions.fetchworklistbyRPCEIDSuccess(response.values));
    } else {
      yield put(actions.fetchworklistbyRPCEIDFailure("No data found"));
    }
  } catch (error) {
    console.error("Worklist Provider Facilities Fetch Error:", error);
    yield put(
      actions.fetchworklistbyRPCEIDFailure(
        "Failed to fetch Worklist Provider Facilities",
      ),
    );
    SweetAlert.error({
      title: "Error!",
      text: "Failed to load Worklist Provider Facilities.",
      showConfirmButton: true,
    });
  }
}

//Get Practice Name by Worklist ID Saga
function* getpracticeNamebyWorklistIDSaga(action) {
  try {
    // Extract payload from action
    const { worklistIds } = action.payload;

    // Call API with worklistIds
    const response = yield call(
      services.GetPracticeNameByWorkListId,
      worklistIds,
    );

    if (response?.success) {
      yield put(actions.fetchpracticebyworklistidSuccess(response.values));
    } else {
      yield put(actions.fetchpracticebyworklistidFailure("No data found"));
      SweetAlert.error({
        title: "Error!",
        text: "No data found for the given Worklist IDs.",
        showConfirmButton: true,
      });
    }
  } catch (error) {
    console.error("Worklist Provider Facilities Fetch Error:", error);
    yield put(
      actions.fetchpracticebyworklistidFailure(
        "Failed to fetch Worklist Provider Facilities",
      ),
    );
    SweetAlert.error({
      title: "Error!",
      text: "Failed to load Worklist Provider Facilities.",
      showConfirmButton: true,
    });
  }
}

//Exporting Encore Service Request Data Saga
function* exportmatrixservicerequestSaga(action) {
  try {
    const response = yield call(
      services.ExportMatrixServiceRequest,
      action.payload,
    );
    const base64Data = response?.values || response;

    if (!base64Data) {
      throw new Error("Empty export response");
    }
    yield call(
      downloadBase64File,
      base64Data,
      "Encore_Service_Request_Facility_Onboarding",
    );

    SweetAlert.success({
      title: "Success",
      text: "Encore Service Request exported successfully",
      icon: "success",
      confirmButtonText: "OK",
      confirmButtonColor: "#6366f1",
      timer: 3000,
      timerProgressBar: true,
    });

    yield put(actions.exportmatrixservicesuccess());
  } catch (error) {
    console.error("Export error:", error);

    SweetAlert.error({
      title: "Error!",
      text: error?.message || "Export failed",
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#d33",
    });

    yield put(
      actions.exportmatrixservicefailure(error?.message || "Export failed"),
    );
  }
}

//Add new service request Saga
function* savematrixserviceRequestSaga(action) {
  try {
    // Call the API
    const response = yield call(
      services.AddNewMatrixServiceRequest,
      action.payload,
    );

    if (!response?.success) {
      const errorMessage =
        response?.errorMessage ||
        response?.message ||
        "Failed to save Requested Facility";
      yield put(actions.addmatrixservicefailure(errorMessage));
      SweetAlert.error({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
      });
      return;
    }

    // Dispatch success action
    yield put(actions.addmatrixservicesuccess(response));
    // Show success notification
    SweetAlert.success({
      title: "Success",
      text: "Successfully Saved Requested Facility",
      icon: "success",
      confirmButtonText: "OK",

      confirmButtonColor: "#8b5cf6",
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        popup: "custom-success-popup",
        title: "custom-success-title",
        content: "custom-success-content",
        confirmButton: "custom-success-button",
      },
    });
    // Fetch updated worklist after successful save
    yield put(actions.fetchMatrixServiceRequest());
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errorMessage ||
      error?.response?.data?.message ||
      "Failed to save Requested Facility";
    console.error("Save Requested Facility API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });
    SweetAlert.error({
      title: "Error",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#d33",
    });
    // Dispatch failure action with error
    yield put(actions.addmatrixservicefailure(errorMessage));
  }
}

//Bulk Save Service Requests Saga
function* BulkSaveMatrixServiceRequestSaga(action) {
  try {
    const payload = action.payload;

    // API call
    const response = yield call(services.BulksaveMatrixServiceRequest, payload);

    // success action
    yield put(actions.bulksavematrixserviceSuccess());

    // success alert
    if (response && response.success) {
      SweetAlert.success({
        title: "Success",
        text: "Successfully Updated All The Requested Facilities Onboarding Details",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#6366f1",
        timer: 3000,
        timerProgressBar: true,
      });
    }

    // refresh table (unmapped = false)
    yield put(actions.fetchMatrixServiceRequest());
  } catch (error) {
    yield put(actions.bulksavematrixserviceFailure(error));

    SweetAlert.error({
      title: "Error",
      text:
        error?.response?.data?.message || "Failed to save site alias mapping",
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#ef4444",
    });
  }
}

//Delete Service Request Saga
function* deleteMatrixServiceSaga(action) {
  try {
    const { id, modifiedBy } = action.payload;

    // Call the API
    yield call(services.DeleteMatrixServiceRequest, id, modifiedBy);

    // Dispatch success action
    yield put(actions.deleteMatrixServiceSuccess(id));

    // Show success notification
    SweetAlert.success({
      title: "Success",
      text: "Successfully Deleted Encore Service Request",
      icon: "success",
      confirmButtonText: "OK",
      confirmButtonColor: "#6366f1",
      timer: 3000,
      timerProgressBar: true,
    });

    // Fetch updated RPCE list after successful delete
    yield put(actions.fetchMatrixServiceRequest());
  } catch (error) {
    let errorMessage = "Failed to delete Encore Service Request";
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#ef4444",
    });
    console.error("Delete Encore Service Request API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });

    // Dispatch failure action with error
    yield put(actions.deleteMatrixServiceFailure(errorMessage));
  }
}

function* fetchAllOnboardingSiteDemandPlannerSaga(action) {
  try {
    const response = yield call(services.GetAllOnboardingSiteDemandPlanner);
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(
      actions.fetchOnboardingSiteDemandPlannerSuccess(response?.values),
    );
  } catch (error) {
    const errorMessage =
      "Failed to fetch Onboarding Facility Demand Planner List";
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#ef4444",
    });
    console.error("Onboarding Facility Demand Planner List API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });
    yield put(actions.fetchOnboardingSiteDemandPlannerFailure(errorMessage));
  }
}

function* fetchAllOnboardingSiteDemandPlannerLegendListSaga(action) {
  try {
    const response = yield call(
      services.GetAllOnboardingSiteDemandPlannerLegendList,
    );
    if (!response) {
      throw new Error("No response received from API");
    }
    yield put(
      actions.fetchOnboardingSiteDemandPlannerLegendListSuccess(
        response?.values,
      ),
    );
  } catch (error) {
    const errorMessage =
      "Failed to fetch Onboarding Facility Demand Planner Legend List";
    SweetAlert.error({
      title: "Error!",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#ef4444",
    });
    console.error("Onboarding Facility Demand Planner Legend List API Error:", {
      status: error.response?.status,
      message: errorMessage,
      data: error.response?.data,
      timestamp: new Date().toISOString(),
    });
    yield put(
      actions.fetchOnboardingSiteDemandPlannerLegendListFailure(errorMessage),
    );
  }
}

// Update Onboarding Facility Demand Planner Data Saga

function* updateMatrixServiceRequestSaga(action) {
  try {
    const payload = action.payload;
    // API call
    const response = yield call(
      services.UpdateOnboardingSiteDemandPlannerData,
      payload,
    );
    // success action
    yield put(actions.updateOnboardingSiteDemandPlannerDataSuccess());
    // success alert
    if (response && response.success) {
      SweetAlert.success({
        title: "Success",
        text: "Successfully Updated Onboarding Facility Demand Planner Data",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#6366f1",
        timer: 3000,
        timerProgressBar: true,
      });
    }
    // refresh table
    yield put(actions.fetchOnboardingSiteDemandPlannerRequest());
  } catch (error) {
    yield put(actions.updateOnboardingSiteDemandPlannerDataFailure(error));
    SweetAlert.error({
      title: "Error",
      text:
        error?.response?.data?.message ||
        "Failed to update Onboarding Facility Demand Planner Data",
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#ef4444",
    });
  }
}

export default function* watchMatrixServiceRequestSaga() {
  yield takeEvery(types.FETCH_MATRIXSERVICE_REQUST, MatrixServiceRequestSaga);
  yield takeEvery(
    types.SITEONBOARDINGPLANNER_DROPDOWN_VALUES_REQUEST,
    fetchAllsiteonboardingplannerlists,
  );
  yield takeEvery(types.GETWORKLISTBY_RPCEID_REQUEST, getworklistbyRpceIDSaga);
  yield takeEvery(types.GETWORKLISTBY_RPCEID_REQUEST, getworklistbyRpceIDSaga);
  yield takeEvery(
    types.GETPRACTICENAMEBY_WORKLIST_REQUEST,
    getpracticeNamebyWorklistIDSaga,
  );
  yield takeEvery(
    types.EXPORT_MATRIXSERVICE_REQUEST,
    exportmatrixservicerequestSaga,
  );
  yield takeEvery(
    types.ADDNEW_SERVICEREQUEST_REQUEST,
    savematrixserviceRequestSaga,
  );
  yield takeEvery(
    types.BULKSAVE_SERVICEREQUEST_REQUEST,
    BulkSaveMatrixServiceRequestSaga,
  );
  yield takeEvery(types.DELETEMATRIXSERVICE_REQUEST, deleteMatrixServiceSaga);
  yield takeEvery(
    types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_REQUEST,
    fetchAllOnboardingSiteDemandPlannerSaga,
  );
  yield takeEvery(
    types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_REQUEST,
    fetchAllOnboardingSiteDemandPlannerLegendListSaga,
  );
  yield takeEvery(
    types.UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_REQUEST,
    updateMatrixServiceRequestSaga,
  );
}
